import React, { useEffect, useState } from 'react';

// "21 oct": el dia de la jornada, detras de su nombre
const conFecha = (jornada) =>
    jornada.fecha
        ? `${jornada.nombre} · ${new Date(jornada.fecha + 'T12:00').toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}`
        : jornada.nombre;

// Desplegable de la clasificacion: la liga o una de las jornadas ya jugadas, la
// mas nueva primero. Las jornadas se crean solas, una por dia de juego; el
// backend solo manda las que tienen algun vino cerrado. Sin ninguna, no sale.
const SelectorJornada = ({ vista, onChange, fija }) => {
    const [jornadas, setJornadas] = useState([]);

    // Se piden otra vez al empezar y al acabar una revelacion: la jornada que se
    // desvela acaba de cerrar su ultimo vino y puede no estar todavia en la lista
    const idFija = fija ? fija.id : null;
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/jornadas`)
            .then((respuesta) => (respuesta.ok ? respuesta.json() : []))
            .then(setJornadas)
            .catch(() => setJornadas([]));
    }, [idFija]);

    // Mientras se desvela una jornada, la clasificacion se queda en ella
    if (fija) {
        return (
            <div className="selector-jornada">
                <span className="jornada-fija">{conFecha(fija)}</span>
            </div>
        );
    }

    if (jornadas.length === 0) {
        return null;
    }

    return (
        <div className="selector-jornada">
            <select value={vista} onChange={(e) => onChange(e.target.value)} aria-label="Ver la clasificación de">
                <option value="liga">Liga</option>
                {jornadas.map((jornada) => (
                    <option key={jornada.id} value={jornada.id}>{conFecha(jornada)}</option>
                ))}
            </select>
        </div>
    );
};

// Puntos de una fila (jugador o winegang) en la vista elegida
export const puntosEn = (vista, fila) =>
    vista === 'liga' ? fila.total_points : (fila.jornadas && fila.jornadas[vista]) || 0;

// Filas de una jornada: solo quien jugo en ella, de mas a menos puntos
export const filasDeJornada = (filas, vista) =>
    filas
        .filter((fila) => fila.jornadas && fila.jornadas[vista] !== undefined)
        .sort((a, b) => b.jornadas[vista] - a.jornadas[vista] || b.total_points - a.total_points);

export default SelectorJornada;
